import { CardType } from '@/types/card'

export const artCrop = (card_or_uid: string | CardType): string => {
  const uid: string = typeof card_or_uid != 'string' ? card_or_uid.id : card_or_uid
  if (!uid || uid.length < 3) return ''
  return `https://card-images.edhrec.com/art_crop/front/${uid[0]}/${uid[1]}/${uid}.jpg`
}
